import userStore from '@/store/user';
import { observer } from 'mobx-react-lite';

const Avatar = observer(({ onClick, className }) => {
  return (
    <img
      onClick={onClick}
      className={['size-36px rounded-8px object-cover', className]}
      src={userStore.showIcon}
      alt=""
    />
  );
});

export default Avatar;